export default __webpack_public_path__ + "static/media/menu-arrow-right.eb223c08.svg";